<div class="tooltip-modal">
  <p [innerHtml]="instructions"></p>
</div>
